import { render } from "./FaqEservicePage.vue?vue&type=template&id=71dfabfe"
import script from "./FaqEservicePage.vue?vue&type=script&lang=js"
export * from "./FaqEservicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__